import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import { withStyles } from "@material-ui/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faBox,
  faHome,
  faBalanceScale,
faSearch,
  faPersonBooth,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../styles/NavbarStyles";

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle(e) {
    this.setState(
      { isExpanded: !this.state.isExpanded },
      console.log(this.state.isExpanded)
    );
    // console.log("clicked");
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.navbar}>
        <div className={classes.logo}>
        <h1 style={{fontWeight:"800",color:"#ffffff",marginBottom:"0px"}}>WEBNIOR</h1>
        </div>
        <nav className={classes.nav}>
          <FontAwesomeIcon
            icon={faBars}
            className={classes.hamburger}
            onClick={this.handleToggle}
          />
          <ul
            className={classNames([classes.navItems], {
              [classes.expand]: this.state.isExpanded,
            })}
          >
            <li className={classes.navItem}>
              <NavLink
                exact
                to="/"
                className={classes.navLinks}
                activeClassName={classes.active}
              >
                <div className={classes.iconBox}>
                  <FontAwesomeIcon icon={faHome} className={classes.icons} />
                  <p>Overview</p>
                </div>
              </NavLink>
            </li>
            <li className={classes.navItem}>
              <NavLink
                exact
                to="/compare"
                className={classes.navLinks}
                activeClassName={classes.active}
              >
                <div className={classes.iconBox}>
                <FontAwesomeIcon icon="" />
                  <FontAwesomeIcon
                    icon={faBalanceScale}  
                    className={classes.icons}
                  />
                  <p>Compare</p>
                </div>
              </NavLink>
            </li>
            <li className={classes.navItem}>
              <NavLink
                exact
                to="/deepanalysis"
                className={classes.navLinks}
                activeClassName={classes.active}
              >
                <div className={classes.iconBox}>
                <FontAwesomeIcon icon="" />
                  <FontAwesomeIcon
                    icon={faSearch}  
                    className={classes.icons}
                  />
                  <p>DeepAnalysis</p>
                </div>
              </NavLink>
            </li>
            <li className={classes.navItem}>
              <NavLink
                exact
                to="/team"
                className={classes.navLinks}
                activeClassName={classes.active}
              >
                <div className={classes.iconBox}>
                  <FontAwesomeIcon icon={faPersonBooth} className={classes.icons} />
                  <p>Team</p>
                </div>
              </NavLink>
            </li>
            <li className={classes.navItem}>
              <NavLink
                exact
                to="/demo"
                className={classes.navLinks}
                activeClassName={classes.active}
              >
                <div className={classes.iconBox}>
                  <FontAwesomeIcon icon={faBox} className={classes.icons} />
                  <p>User Demo</p>
                </div>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default withStyles(styles)(Navbar);
